import BaseClient from '@/app/model/api/response/baseApiClient'

class GraphItemApi extends BaseClient {
  public getGraphItem (fieldId: string) {
    const path = '/v1/field/graph/item'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ field_id: JSON.parse(fieldId) })
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new GraphItemApi()
